module.exports = __webpack_public_path__ + "img/colocation.846a223.webp";